
import { useEffect, useState } from "react";
import { requester } from "App.js";
import Container from "layouts/container/Container";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import style from "./DeviceList.module.css"
import P from "components/P";
function NormalType({ storeId }) {

    const [storeProduct, setStoreProduct] = useState([]);
    useEffect(() => {
        let data = { storeId };
        requester.findAllByStoreIdWithCategory(data, (result) => {
            setStoreProduct(result.data);
        });
    }, [storeId]);

    return (
        <div>
            <Container>
                <VerticalFlex>
                    <FlexChild>
                        <HorizontalFlex>
                            <FlexChild>
                                <div className={style.vapeList}>
                                    {storeProduct
                                        .filter(item => item.categoryName === "과일" || item.categoryName === "디저트" || item.categoryName === "멘솔 연초")
                                        .map((item, index) => {
                                            return (
                                                <div key={index} style={{ flex: "1 1 50%" }}>
                                                    <img
                                                        src={item.productImg}
                                                        style={{ width: "80%", height: "80%" }}
                                                    />
                                                    <P weight={"bold"} size={15}>{item.productName}</P>
                                                    <P weight={"bold"} size={15}>{item.price.toLocaleString()}원</P>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );

}
export default NormalType